var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Social")]),_vm._v(" "),_c('transition-group',{attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.timeline),function(entry){return _c('TimelineEntry',{key:entry.id,attrs:{"item":entry}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }